import React, { useState, useEffect, useRef } from 'react';
import { Mail, Phone, MapPin, Send, CheckCircle, AlertCircle } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// SVG Icons for messaging apps
const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

const KakaoTalkIcon = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
    <path d="M12 3c5.799 0 10.5 3.664 10.5 8.185 0 4.52-4.701 8.184-10.5 8.184a13.5 13.5 0 01-1.727-.11l-4.408 2.883c-.501.265-.678.236-.472-.413l.892-3.678c-2.88-1.46-4.785-3.99-4.785-6.866C1.5 6.665 6.201 3 12 3zm5.907 8.06l1.47-1.424a.472.472 0 00-.656-.678l-1.928 1.866V9.282a.472.472 0 00-.944 0v2.557a.471.471 0 000 .222V13.5a.472.472 0 00.944 0v-1.363l.427-.413 1.428 2.033a.472.472 0 10.773-.543l-1.514-2.154zm-2.958 1.924h-1.46V9.297a.472.472 0 00-.943 0v4.159c0 .26.21.472.471.472h1.932a.472.472 0 100-.944zm-5.857-1.092l.696-1.707.638 1.707H9.092zm2.523.488l.002-.016a.469.469 0 00-.127-.32l-1.046-2.8a.69.69 0 00-.627-.474.696.696 0 00-.653.447l-1.661 4.075a.472.472 0 00.874.357l.33-.813h2.07l.299.8a.472.472 0 10.884-.33l-.345-.926zM8.293 9.302a.472.472 0 00-.471-.472H4.577a.472.472 0 100 .944h1.16v3.736a.472.472 0 00.944 0V9.774h1.14c.261 0 .472-.212.472-.472z"/>
  </svg>
);

const WeChatIcon = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
    <path d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 01.213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.326.326 0 00.167-.054l1.903-1.114a.864.864 0 01.717-.098 10.16 10.16 0 002.837.403c.276 0 .543-.027.811-.05-.857-2.578.157-4.972 1.932-6.446 1.703-1.415 3.882-1.98 5.853-1.838-.576-3.583-4.196-6.348-8.596-6.348zM5.785 5.991c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 01-1.162 1.178A1.17 1.17 0 014.623 7.17c0-.651.52-1.18 1.162-1.18zm5.813 0c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 01-1.162 1.178 1.17 1.17 0 01-1.162-1.178c0-.651.52-1.18 1.162-1.18zm5.34 2.867c-1.797-.052-3.746.512-5.28 1.786-1.72 1.428-2.687 3.72-1.78 6.22.942 2.453 3.666 4.229 6.884 4.229.826 0 1.622-.12 2.361-.336a.722.722 0 01.598.082l1.584.926a.272.272 0 00.14.045c.134 0 .24-.111.24-.247 0-.06-.023-.12-.038-.177l-.327-1.233a.582.582 0 01-.023-.156.49.49 0 01.201-.398C23.024 18.48 24 16.82 24 14.98c0-3.21-2.931-5.837-6.656-6.088V8.89c-.135-.01-.27-.027-.407-.03zm-2.53 3.274c.535 0 .969.44.969.982a.976.976 0 01-.969.983.976.976 0 01-.969-.983c0-.542.434-.982.97-.982zm4.844 0c.535 0 .969.44.969.982a.976.976 0 01-.969.983.976.976 0 01-.969-.983c0-.542.434-.982.969-.982z"/>
  </svg>
);

const ContactSection = () => {
  const { t, positioning, language } = useLanguage();
  const sectionRef = useRef(null);
  const [formData, setFormData] = useState({
    name: '',
    agency_name: '',
    country: '',
    email: '',
    message: ''
  });
  const [status, setStatus] = useState({ type: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = sectionRef.current?.querySelectorAll('.animate-on-scroll');
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus({ type: '', message: '' });

    if (!API_URL) {
      setStatus({ type: 'error', message: t.contact.error });
      setIsSubmitting(false);
      return;
    }

    try {
      const response = await axios.post(`${API_URL}/api/contact`, {
        ...formData,
        language: language
      });

      if (response.data.status === 'success') {
        setStatus({ type: 'success', message: t.contact.success });
        setFormData({
          name: '',
          agency_name: '',
          country: '',
          email: '',
          message: ''
        });
      }
    } catch (error) {
      console.error('Contact form error:', error);
      if (error.response?.status === 422) {
        setStatus({ type: 'error', message: t.contact.validationError || t.contact.error });
      } else if (error.response?.status >= 500) {
        setStatus({ type: 'error', message: t.contact.serverError || t.contact.error });
      } else {
        setStatus({ type: 'error', message: t.contact.error });
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section 
      id="contact" 
      ref={sectionRef}
      className="py-32 md:py-40 bg-soft-black relative"
      data-testid="contact-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-20 animate-on-scroll">
          <p className="text-[11px] font-medium tracking-[0.25em] uppercase text-zinc-500 mb-4" data-testid="contact-overline">
            {t.contact.overline}
          </p>
          <h2 
            className="font-serif text-4xl md:text-5xl lg:text-6xl font-normal tracking-tight text-white mb-6"
            data-testid="contact-title"
          >
            {t.contact.title}
          </h2>
          <p className="text-zinc-500 text-base md:text-lg max-w-xl mx-auto font-light">
            {t.contact.subtitle}
          </p>
          <div className="w-16 h-px bg-white/20 mx-auto mt-8" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-16 lg:gap-20">
          {/* Contact Info */}
          <div className="lg:col-span-2 space-y-10 animate-on-scroll">
            {/* Email */}
            <div className="flex items-start gap-5 group">
              <div className="w-14 h-14 flex-shrink-0 flex items-center justify-center border border-white/10 group-hover:border-white/30 transition-colors duration-500">
                <Mail className="w-5 h-5 text-white/50 group-hover:text-white transition-colors duration-500" />
              </div>
              <div>
                <p className="text-xs tracking-[0.15em] uppercase text-zinc-600 mb-2">Email</p>
                <a 
                  href="mailto:info@kaesthetic.world" 
                  className="text-white hover:text-zinc-300 transition-colors text-sm"
                  data-testid="contact-email"
                >
                  info@kaesthetic.world
                </a>
              </div>
            </div>

            {/* Phone Europe + WhatsApp */}
            <div className="flex items-start gap-5 group">
              <div className="w-14 h-14 flex-shrink-0 flex items-center justify-center border border-white/10 group-hover:border-white/30 transition-colors duration-500">
                <Phone className="w-5 h-5 text-white/50 group-hover:text-white transition-colors duration-500" />
              </div>
              <div>
                <p className="text-xs tracking-[0.15em] uppercase text-zinc-600 mb-2">{t.contact.phone.europe}</p>
                <a 
                  href="tel:+34662408398" 
                  className="text-white hover:text-zinc-300 transition-colors text-sm block mb-2"
                  data-testid="contact-phone-europe"
                >
                  +34 662 40 83 98
                </a>
                <a 
                  href="https://wa.me/34662408398"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-zinc-500 hover:text-white transition-colors text-xs"
                  data-testid="contact-whatsapp"
                >
                  <WhatsAppIcon />
                  <span>WhatsApp</span>
                </a>
              </div>
            </div>

            {/* Phone Asia + KakaoTalk + WeChat */}
            <div className="flex items-start gap-5 group">
              <div className="w-14 h-14 flex-shrink-0 flex items-center justify-center border border-white/10 group-hover:border-white/30 transition-colors duration-500">
                <Phone className="w-5 h-5 text-white/50 group-hover:text-white transition-colors duration-500" />
              </div>
              <div>
                <p className="text-xs tracking-[0.15em] uppercase text-zinc-600 mb-2">{t.contact.phone.asia}</p>
                <a 
                  href="tel:+821044538035" 
                  className="text-white hover:text-zinc-300 transition-colors text-sm block mb-2"
                  data-testid="contact-phone-asia"
                >
                  +82 10 4453 8035
                </a>
                <div className="flex items-center gap-4">
                  <a 
                    href="https://open.kakao.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Contact us on KakaoTalk"
                    className="inline-flex items-center gap-2 text-zinc-500 hover:text-white transition-colors text-xs"
                    data-testid="contact-kakaotalk"
                  >
                    <KakaoTalkIcon />
                    <span>KakaoTalk</span>
                  </a>
                  <a 
                    href="weixin://"
                    title="WeChat ID: kaesthetic"
                    className="inline-flex items-center gap-2 text-zinc-500 hover:text-white transition-colors text-xs"
                    data-testid="contact-wechat"
                  >
                    <WeChatIcon />
                    <span>WeChat</span>
                  </a>
                </div>
              </div>
            </div>

            {/* Location */}
            <div className="flex items-start gap-5 group">
              <div className="w-14 h-14 flex-shrink-0 flex items-center justify-center border border-white/10 group-hover:border-white/30 transition-colors duration-500">
                <MapPin className="w-5 h-5 text-white/50 group-hover:text-white transition-colors duration-500" />
              </div>
              <div>
                <p className="text-xs tracking-[0.15em] uppercase text-zinc-600 mb-2">Location</p>
                <p className="text-white text-sm" data-testid="contact-location">
                  {positioning.companyLocation}
                </p>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="lg:col-span-3 animate-on-scroll" style={{ transitionDelay: '0.15s' }}>
            <form 
              onSubmit={handleSubmit} 
              className="space-y-8"
              data-testid="contact-form"
            >
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                {/* Name */}
                <div>
                  <label htmlFor="name" className="block text-xs tracking-[0.15em] uppercase text-zinc-600 mb-3">
                    {t.contact.form.name} *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="input-premium"
                    data-testid="input-name"
                  />
                </div>

                {/* Agency Name */}
                <div>
                  <label htmlFor="agency_name" className="block text-xs tracking-[0.15em] uppercase text-zinc-600 mb-3">
                    {t.contact.form.agency} *
                  </label>
                  <input
                    type="text"
                    id="agency_name"
                    name="agency_name"
                    value={formData.agency_name}
                    onChange={handleChange}
                    required
                    className="input-premium"
                    data-testid="input-agency"
                  />
                </div>

                {/* Country */}
                <div>
                  <label htmlFor="country" className="block text-xs tracking-[0.15em] uppercase text-zinc-600 mb-3">
                    {t.contact.form.country} *
                  </label>
                  <input
                    type="text"
                    id="country"
                    name="country"
                    value={formData.country}
                    onChange={handleChange}
                    required
                    className="input-premium"
                    data-testid="input-country"
                  />
                </div>

                {/* Email */}
                <div>
                  <label htmlFor="email" className="block text-xs tracking-[0.15em] uppercase text-zinc-600 mb-3">
                    {t.contact.form.email} *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="input-premium"
                    data-testid="input-email"
                  />
                </div>
              </div>

              {/* Message */}
              <div>
                <label htmlFor="message" className="block text-xs tracking-[0.15em] uppercase text-zinc-600 mb-3">
                  {t.contact.form.message} *
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows={5}
                  placeholder={t.contact.form.messagePlaceholder}
                  className="input-premium resize-none"
                  data-testid="input-message"
                />
              </div>

              {/* Status Message */}
              {status.message && (
                <div 
                  className={`flex items-center gap-3 p-4 border ${
                    status.type === 'success' 
                      ? 'border-white/20 text-white bg-white/5' 
                      : 'border-red-500/30 text-red-400 bg-red-500/5'
                  }`}
                  data-testid="form-status"
                >
                  {status.type === 'success' ? (
                    <CheckCircle className="w-5 h-5 flex-shrink-0" />
                  ) : (
                    <AlertCircle className="w-5 h-5 flex-shrink-0" />
                  )}
                  <span className="text-sm">{status.message}</span>
                </div>
              )}

              {/* Submit Button */}
              <button
                type="submit"
                disabled={isSubmitting}
                className="btn-primary w-full sm:w-auto flex items-center justify-center gap-3 disabled:opacity-50 disabled:cursor-not-allowed"
                data-testid="submit-button"
              >
                {isSubmitting ? (
                  <>
                    <div className="w-4 h-4 border-2 border-black/30 border-t-black rounded-full animate-spin" />
                    <span>{t.contact.form.sending}</span>
                  </>
                ) : (
                  <>
                    <Send className="w-4 h-4" />
                    <span>{t.contact.form.submit}</span>
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
